import React, { useState, useEffect } from "react";
import { Container, Form, Button, Table, Card, Image } from "react-bootstrap";
import axios from "axios";

const API_URL = "https://madhusewingmachines.com/api/categories"; // Backend API base URL

const AdminCategories = () => {
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState({ name: "", categoryimg: null });
    const [imagePreview, setImagePreview] = useState(null);

    // Fetch categories from backend
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${API_URL}/getcategory`);
            setCategories(response.data);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    // Handle form input changes
    const handleChange = (e) => {
        if (e.target.name === "categoryimg") {
            const file = e.target.files[0];
            if (file) {
                setNewCategory({ ...newCategory, categoryimg: file });
                setImagePreview(URL.createObjectURL(file));
            }
        } else {
            setNewCategory({ ...newCategory, [e.target.name]: e.target.value });
        }
    };

    // Add category via API
    const addCategory = async () => {
        if (!newCategory.name || !newCategory.categoryimg) {
            alert("Please enter a category name and select an image.");
            return;
        }

        const formData = new FormData();
        formData.append("name", newCategory.name);
        formData.append("categoryimg", newCategory.categoryimg);

        try {
            await axios.post(`${API_URL}/addcategory`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setNewCategory({ name: "", categoryimg: null });
            setImagePreview(null);
            fetchCategories(); // Refresh category list
        } catch (error) {
            console.error("Error adding category:", error);
        }
    };

    // Delete category via API
    const removeCategory = async (id) => {
        if (!window.confirm("Are you sure you want to delete this category?")) return;

        try {
            await axios.delete(`${API_URL}/deletecategory/${id}`);
            setCategories(categories.filter((category) => category._id !== id)); // Optimistic update
        } catch (error) {
            console.error("Error deleting category:", error);
            alert(error.response?.data?.error || "Failed to delete category");
        }
    };

    return (
        <Container className="py-4">
            <h1 className="text-center fw-bold mb-4">📂 Manage Categories</h1>

            {/* Add Category */}
            <Card className="p-4 mb-4 shadow-sm">
                <h4 className="fw-semibold mb-3">Add New Category</h4>
                <div className="d-flex gap-3">
                    <Form.Control
                        type="text"
                        name="name"
                        value={newCategory.name}
                        onChange={handleChange}
                        placeholder="Category Name"
                    />
                    <Form.Control type="file" name="categoryimg" onChange={handleChange} />
                    <Button variant="primary" onClick={addCategory}>
                        Add
                    </Button>
                </div>

                {/* Image Preview */}
                {imagePreview && (
                    <div className="mt-3">
                        <Image src={imagePreview} width={150} height={100} rounded />
                    </div>
                )}
            </Card>

            {/* Category Table */}
            <Card className="p-3 shadow-sm">
                <h4 className="fw-semibold mb-3">Categories List</h4>
                <Table striped bordered hover responsive>
                    <thead className="table-dark">
                        <tr>
                            <th>ID</th>
                            <th>Image</th>
                            <th>Category Name</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((category) => (
                            <tr key={category._id} className="text-center">
                                <td>{category._id}</td>
                                <td>
                                    <img
                                        src={`https://madhusewingmachines.com/uploads/${category.categoryimg}`}
                                        width={100}
                                        height={70}
                                        alt="Category"
                                    />
                                </td>
                                <td>{category.name}</td>
                                <td>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => removeCategory(category._id)}
                                    >
                                        Delete
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>
        </Container>
    );
};

export default AdminCategories;
